import { GraphQL } from "@rpi/openapi-api";
import { OrdersTable } from "../../orders/OrdersTable";

type Payment = NonNullable<GraphQL.PaymentQuery["payment"]>;

interface PaymentOrdersTabProps {
  payment: Payment | undefined;
  isLoading: boolean;
}

// No sort / no pagination: paidOrders is a nested field on Payment, and the
// `orders` query has no paymentId filter to swap to.
export function PaymentOrdersTab({ payment, isLoading }: PaymentOrdersTabProps) {
  return <OrdersTable orders={payment?.paidOrders ?? []} isLoading={isLoading} />;
}
